import { createTheme } from '@mui/material';
import { theme as defaultTheme } from './theme';
const theme = createTheme(defaultTheme);

export default theme;
